module.exports = __webpack_public_path__ + "static/media/fake.ca10aa43.webp";